export function getResolvedTimeZoneId(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone?.trim() || null;
  } catch {
    return null;
  }
}
